const SERVICE_NAME = 'child-badges';
import backend from "@/lib/backend";
export default axios => ({
    getChildBadges(id) {
        return backend(axios, SERVICE_NAME).get(id);
    }
});